/**
 * 결정론적 PRNG (mulberry32). 같은 seed → 항상 같은 0~1 수열.
 * 반환 시그니처는 modulePieces의 `PieceRandomSource`(() => number)와 동형이라
 * 가중 추첨 등 기존 rng 주입 함수에 그대로 넘길 수 있다.
 *
 * 용도: 챕터 번호를 seed로 주면 "고정형 랜덤" 벽돌 그리드를 재현 가능하게 생성한다
 * (ChapterBrickLayout). 저장 없이 currentChapter만으로 같은 모양을 복원한다.
 */
export function makeRng(seed: number): () => number {
  let a = seed >>> 0;
  return () => {
    a = (a + 0x6d2b79f5) | 0;
    let t = Math.imul(a ^ (a >>> 15), 1 | a);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}
